import { FormattedMessage } from "react-intl";

// assets
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AssessmentIcon from "@mui/icons-material/Assessment";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { IconSettings, IconList } from "@tabler/icons";
import PersonIcon from "@mui/icons-material/Person";

// import restaurantIcon from "assets/images/widget/restaurantIcon.svg"

const AllOther = {
  id: "sample-docs-roadmap",
  type: "group",
  children: [
    // {
    //   id: "Category",
    //   title: "Categories",
    //   type: "collapse",
    //   // url: "/raffle-categories",
    //   icon: IconList,
    //   breadcrumbs: false,
    //   children: [
    //     {
    //       id: "menu-category",
    //       title: <FormattedMessage id="Menu Categories" />,
    //       type: "item",
    //       url: "/menu-category",
    //     },
    //     {
    //       id: "restaurant-category",
    //       title: <FormattedMessage id="Restaurant Categories" />,
    //       type: "item",
    //       url: "/restaurant-category",
    //     },
    //   ],
    // },
    // {
    //   id: "Admins",
    //   title: <FormattedMessage id="Admins" />,
    //   type: "item",
    //   url: "/admins",
    //   // icon: <img src={restaurantIcon} alt="restaurant icon" />,
    //   icon: PersonIcon,
    //   breadcrumbs: false,
    // },
    {
      id: "Restaurant",
      title: <FormattedMessage id="Restaurant" />,
      type: "item",
      url: "/sire-profile",
      // icon: <img src={restaurantIcon} alt="restaurant icon" />,
      icon: RestaurantIcon,
      breadcrumbs: false,
    },
    // {
    //   id: "Import Restaurant",
    //   title: <FormattedMessage id="Import Restaurant" />,
    //   type: "item",
    //   url: "/import/restaurant",
    //   icon: RestaurantIcon,
    //   breadcrumbs: false,
    // },
    // {
    //   id: "Notifications",
    //   title: <FormattedMessage id="Notifications" />,
    //   type: "item",
    //   url: "/notifications",
    //   icon: NotificationsNoneIcon,
    //   breadcrumbs: false,
    // },
    // {
    //   id: "Report",
    //   title: <FormattedMessage id="Report" />,
    //   type: "item",
    //   url: "/report",
    //   icon: AssessmentIcon,
    //   breadcrumbs: false,
    // },
    // {
    //   id: "Settings",
    //   title: <FormattedMessage id="Settings" />,
    //   type: "collapse",
    //   icon: IconSettings,
    //   // url: "/settings",
    //   breadcrumbs: false,
    //   children: [
    //     {
    //       id: "General",
    //       title: <FormattedMessage id="General" />,
    //       type: "item",
    //       url: "/settings/general",
    //     },
    //     {
    //       id: "Restaurant Images",
    //       title: <FormattedMessage id="Restaurant Images" />,
    //       type: "item",
    //       url: "/settings/restaurant-images",
    //     },
    //     {
    //       id: "Menu Images",
    //       title: <FormattedMessage id="Menu Images" />,
    //       type: "item",
    //       url: "/settings/menu-images",
    //     },
    //   ],
    // },
  ],
};

export default AllOther;
